import { combineReducers } from 'redux';
import { buildReducer, buildModuleReducer } from './buildReducer';
import accountsReducer from './accountsModuleReducer';
import savingsReducer from './savingsModuleReducer';
import dashboardReducer from './dashboardReducer';
import investmentMixReducer from './investmentMixReducer';
import socialSecurityReducer from './socialSecurityReducer';
import spendingPlanReducer from './spendingPlanReducer';
import taxStrategyReducer from './taxStrategyReducer';
import guaranteedIncomeReducer from './guaranteedIncomeReducer';
import wealthManagementReducer from './wealthManagementReducer';

export default combineReducers({
  dashboard: dashboardReducer,
  accounts: accountsReducer,
  jobs: buildModuleReducer({ fetchAction: 'JOBS_MODULE_FETCHED' }),
  savings: savingsReducer,
  incomes: buildReducer({ fetchAction: 'INCOMES_FETCHED' }),
  investmentMix: investmentMixReducer,
  socialSecurity: socialSecurityReducer,
  spendingPlan: spendingPlanReducer,
  taxStrategy: taxStrategyReducer,
  guaranteedIncome: guaranteedIncomeReducer,
  wealthManagement: wealthManagementReducer,
});
